import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../../firebase/config";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({
  children
}: {
  children: React.ReactNode;
}) {
  const [user, loading] = useAuthState(auth);

  if (loading) return <p>Loading...</p>;

  // If not logged in, kick them to login page
  if (!user) return <Navigate to="/login" />;

  return <>{children}</>;
}